import React from 'react';
import {fileColName, InvalidCellReason} from './FileEnum';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const InvalidFileLines = ({invalidLineFile, UploadNewFile, upgradeOrActivate}) => {
  const shouldHideNameColumns = upgradeOrActivate === 'upgrade';
  const hiddenColumns = ['firstName', 'lastName'];
  const InvalidRows = invalidLineFile.map((response, rowIndex) => {
    const {line, invalidCells} = response;
    return (
      <div className='row_wrapper' key={rowIndex}>
        {Object.keys(line).map((key, cellIndex) => {
          if (shouldHideNameColumns && hiddenColumns.includes(key)) {
            return null;
          }
          const isInvalid = invalidCells[key];
          const cellName = fileColName[key];
          const cellValue = !line[key] ? InvalidCellReason[invalidCells[key]] : line[key];
          return (
            <>
              {cellName && (
                <div className='row_cell' key={cellIndex}>
                  <div className='cell_key'>{cellName}</div>
                  <div key={key} className={`cell_value ${isInvalid ? 'cell_invalid' : ''}`}>
                    {cellValue}
                  </div>
                </div>
              )}
            </>
          );
        })}
        {/* <img className='arrow_left'  src={require('./icons/arrow-left.svg')}></img> */}
      </div>
    );
  });

  return (
    <div className='invalidLineContainer'>
      <div className='title'>שורות שאינן תקינות</div>

      <div className='invalidRows'>{InvalidRows}</div>
      <BtnSubmit onclick={() => UploadNewFile()} text={'לטעינת קובץ תקין'} />
    </div>
  );
};

export default InvalidFileLines;
